const quickLinks = {}
quickLinks["de-de"] = [
  {
    name: "Produkt registrieren",
    url: "https://rothenberger.infotip-rts.com/Service.xhtml",
  },
  {
    name: "Schulungen",
    url: "/de-de/service/schulungen",
  },
  {
    name: "Produktneuheiten",
    url: "/de-de/produktnews",
  },
  {
    name: "Mediendatenbank",
    url: "/de-de/service/mediendatenbank",
  },
]

quickLinks["rfo"] = [
  {
    name: "Produktbereiche",
    url: "/de-de/produkte",
  },
  {
    name: "Über uns",
    url: "/de-de/ueber-uns",
  },
  {
    name: "Kontakt",
    url: "/de-de/kontakt",
  },
]

module.exports = {
  quickLinks: quickLinks,
}
